import { readFormVersion } from '@module/form';
import { FormEditPageState } from './form-edit.states';

/**
 * Keep draft form.version in sync after mutation APIs.
 * Mutates the existing Form instance in place so we do NOT change formResponse
 * reference — replacing Form was re-triggering question list refetch (flash/scroll).
 */
export function withSyncedFormVersion(
  state: FormEditPageState,
  formVersion?: number,
): Record<string, never> {
  if (typeof formVersion === 'number' && state.formResponse) {
    state.formResponse.updateVersion(formVersion);
  }
  return {};
}

export function withSyncedFormVersionFromEntity(
  state: FormEditPageState,
  entity: unknown,
): Record<string, never> {
  return withSyncedFormVersion(state, readFormVersion(entity));
}
